var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50005 3.75C10.1227 3.75 10.7199 3.98705 11.1602 4.40901C11.6005 4.83097 11.8479 5.40326 11.8479 6C11.8479 6.59674 11.6005 7.16903 11.1602 7.59099C10.7199 8.01295 10.1227 8.25 9.50005 8.25C8.87737 8.25 8.28019 8.01295 7.83989 7.59099C7.39959 7.16903 7.15223 6.59674 7.15223 6C7.15223 5.40326 7.39959 4.83097 7.83989 4.40901C8.28019 3.98705 8.87737 3.75 9.50005 3.75ZM9.50005 0.375C13.4131 0.375 16.7548 2.7075 18.1087 6C16.7548 9.2925 13.4131 11.625 9.50005 11.625C5.58701 11.625 2.24527 9.2925 0.891357 6C2.24527 2.7075 5.58701 0.375 9.50005 0.375ZM2.59744 6C3.22999 7.23773 4.21221 8.28056 5.43243 9.00994C6.65265 9.73932 8.06193 10.126 9.50005 10.126C10.9382 10.126 12.3475 9.73932 13.5677 9.00994C14.7879 8.28056 15.7701 7.23773 16.4027 6C15.7701 4.76227 14.7879 3.71944 13.5677 2.99006C12.3475 2.26068 10.9382 1.87401 9.50005 1.87401C8.06193 1.87401 6.65265 2.26068 5.43243 2.99006C4.21221 3.71944 3.22999 4.76227 2.59744 6Z",
    fill: "#7F56DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector10);
export default __webpack_public_path__ + "static/media/Vector (10).093a379973d87559d90d1f8db16cf237.svg";
export { ForwardRef as ReactComponent };